export const useTimeParser = () => {
    // Convertir de HH:MM:SS a HH:MM para el formulario
    const parseTime = (timeString) => {
        if (!timeString) return '';
        
        if (timeString.includes(':')) {
            const timeParts = timeString.split(':');
            if (timeParts.length >= 2) {
                return `${timeParts[0]}:${timeParts[1]}`;
            }
        }
        return timeString;
    };

    return {
        parseTime
    };
};